import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-folder";

export const pagingPatientFolder = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getPatientFolderById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdatePatientFolder = (obj) =>
  axios.post(API_PATH + "/save-patient-folder", obj);

export const deletePatientFolder = (id) =>
  axios.delete(API_PATH + "/mark-delete/" + id);

export const addNewFilesPatientFolder = (obj) =>
  axios.post(API_PATH + "/add-new-files", obj);

export const deletePatientFolderByDate = (obj) =>
  axios.post(API_PATH + "/void-files-in-date", obj);

export const deleteFilesPatientInFolder = (obj) =>
  axios.post(API_PATH + "/void-files-in-folder", obj);

export const savePatientFolderVttech = (id) =>
  axios.get(API_PATH + `/save-patient-folder-vttech/${id}`);

export const voidFilePatientFolder = (id) =>
  axios.post(API_PATH + `/void-file/${id}`);
